import React, { useState, useEffect } from 'react'
import { Modal, Select, Input, Radio } from 'antd'
import { DISPUTE_REASONS, validateDispute } from '../../pages/invoices/invoiceReview'
import { dsButtonPrimary, dsButtonSecondary, dsButtonSpinnerInline, joinButtonClasses } from '../../utils/buttonStyles'

// Dispute for an invoice under HR review: a reason code, an optional comment
// (required for Other) and either the selected rows or the whole invoice.
const InvoiceReviewDisputeModal = ({ visible = false, invoiceNo = '', selectedCount = 0, submitting = false, serverError = '', close = () => {}, submitHandler = () => {} }) => {
  const [reasonCode, setReasonCode] = useState(undefined)
  const [comment, setComment] = useState('')
  const [scope, setScope] = useState('whole')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!visible) return
    setReasonCode(undefined)
    setComment('')
    setScope(selectedCount > 0 ? 'selected' : 'whole')
    setError('')
  }, [visible])

  const handler = () => {
    const message = validateDispute({ reasonCode, comment })
    if (message) setError(message)
    else submitHandler({ reasonCode, comment, scope: selectedCount > 0 ? scope : 'whole' })
  }

  const rowsLabel = `Dispute ${selectedCount} selected ${selectedCount === 1 ? 'row' : 'rows'}`

  return (
    <Modal visible={visible} centered width='560px' footer={null} onCancel={close} maskClosable={!submitting}>
      <h1 className='text-xl mb-1 font-extrabold text-gray-700'>Dispute invoice {invoiceNo}</h1>
      <p className='mb-5 text-gray-500'>We will send this to ekincare finance.</p>

      <label className='block mb-1 font-semibold text-gray-700'>Reason</label>
      <Select
        value={reasonCode}
        placeholder='Choose a reason'
        className='w-full'
        onChange={(value) => { setReasonCode(value); setError('') }}
      >
        {DISPUTE_REASONS.map((reason) => <Select.Option key={reason.value} value={reason.value}>{reason.label}</Select.Option>)}
      </Select>

      <label className='block mt-4 mb-1 font-semibold text-gray-700'>Comment {reasonCode === 'other' ? '' : <span className='font-normal text-gray-500'>(optional)</span>}</label>
      <Input.TextArea rows={3} value={comment} onChange={(event) => { setComment(event.target.value); setError('') }} />

      <div className='mt-4 text-gray-700'>
        {selectedCount > 0 ?
          <Radio.Group value={scope} onChange={(event) => setScope(event.target.value)}>
            <Radio value='selected'>{rowsLabel}</Radio>
            <Radio value='whole'>Dispute the whole invoice</Radio>
          </Radio.Group>
          :
          <span className='font-semibold'>Dispute the whole invoice</span>
        }
      </div>

      {(error || serverError) && <p className='mb-0 mt-3 text-red-600'>{error || serverError}</p>}

      <div className='mt-6 flex justify-end gap-3'>
        <button onClick={close} disabled={submitting} className={joinButtonClasses(dsButtonSecondary, 'h-11 px-5')}>Cancel</button>
        <button onClick={handler} disabled={submitting} className={joinButtonClasses(dsButtonPrimary, 'h-11 px-5', submitting && dsButtonSpinnerInline)}>
          {submitting ? 'Sending…' : 'Send to ekincare finance'}
        </button>
      </div>
    </Modal>
  )
}

export default InvoiceReviewDisputeModal
